import { notification } from "ant-design-vue";

// Client users land on the Team Dashboard by default after login/reload.
// Kept as a helper so the landing target stays in one place if it changes.
// eslint-disable-next-line no-unused-vars
export function resolveClientLandingRoute(user) {
  return "/client/team-dashboard";
}

export const getDefaultNotificationOBj = (msg, error) => {
  return {
    message: msg,
    placement: "topRight",
    bottom: error ? "10px" : "50px",
    duration: 3,
    style: {
      width: "350px",
      marginLeft: `${335 - 600}px`,
      background: error ? "#fd625e" : "#2ab57d",

    },
  };
};

// Single place to read an error message out of an API error response.
// If the backend ever standardizes on a different key, update it here only.
export const getErrorMessage = (error, fallbackMessage = "Something went wrong") => {
  const responseData = error?.response?.data || error;

  // if (typeof responseData?.data === "string" && responseData.data.trim()) {
  //   return responseData.data;
  // }
  if (typeof responseData?.message === "string" && responseData.message.trim()) {
    return responseData.message;
  }
  if (Array.isArray(responseData?.message) && responseData.message.length) {
    return responseData.message.join(", ");
  }
  if (typeof responseData?.error === "string" && responseData.error.trim()) {
    return responseData.error;
  }
  if (Array.isArray(responseData?.error) && responseData.error.length) {
    return responseData.error.join(", ");
  }

  return fallbackMessage;
};

// Extracts the error message and shows it via the standard error toast.
// Safe to call unconditionally in a catch block regardless of status code
// or whether the error even has a response (e.g. network failures).
export const showApiError = (error, fallbackMessage = "Something went wrong") => {
  const message = getErrorMessage(error, fallbackMessage);
  notification.open(getDefaultNotificationOBj(message, true));
  return message;
};

// A neutral heads-up toast — for messages that explain why an action was
// blocked or adjusted, not that something actually went wrong (that's
// showApiError). Uses antd's native "info" style: white card, blue ℹ icon.
export const showInfo = (message) => {
  notification.info({
    message,
    placement: "topRight",
    duration: 3,
  });
};




export const dateFormatter = (dateString) => {
  const date = new Date(dateString);
const year = date.getFullYear();
const month = String(date.getMonth() + 1).padStart(2, '0');
const day = String(date.getDate()).padStart(2, '0');
const formattedDate = `${day}-${month}-${year}`;

  return formattedDate
};




// export const searchData = (text, arr) => {
//   if(text) {
//     const lowerCaseValue = text.toLowerCase();
//     const filteredData = arr.filter(el =>  {
//             console.log({el})
//             const values = Object.values(el).filter(el => typeof el === "string");
//             console.log(values)
//             return values.some(e => e.toLowerCase().includes(lowerCaseValue));
//           });
   
//     return  filteredData;
//   }


//   return arr;
  
// };

export const searchData = (text, arr) => {
  if (text) {
    const words = text.toLowerCase().split(/\s+/).filter(Boolean);
    const filteredData = arr.filter(el => {
      const values = Object.values(el).filter(val => typeof val === "string" || typeof val === "number");
      return words.every(word =>
        values.some(val =>
          typeof val === "string"
            ? val.toLowerCase().includes(word)
            : val.toString().includes(word)
        )
      );
    });

    return filteredData;
  }

  return arr;
};




export const  theAddFunction =  async ({values,Service, preAPICall,  onSuccess, isUpdate = false}) => {
  try {
      preAPICall();
     const response = await Service.add(values);
    if (response.success == true) {
      notification.open({   
        message: response.message,
        placement: "topRight",
        bottom: "50px",
        duration: 3,
        style: {
          width: "350px",
          marginLeft: `${335 - 600}px`,
          background: "#2ab57d",
        },
      });
      onSuccess();
    }
   } catch (error) {
    showApiError(error);
  }
}



export function toValidVariableName(str) {
  return str
      .toLowerCase()                     // Convert to lowercase
      .replace(/[^a-zA-Z0-9_$]/g, "_")    // Replace invalid characters with "_"
      .replace(/^[_\d]+/, "")             // Remove leading underscores and digits if necessary
      || "var_name";                      // Fallback if the string is empty
}

const appEnvironment = window.APP_CONFIG?.serverIp || process.env.VUE_APP_SERVER_IP;

// Tawk to 
export async function loadTawkTo() {
  return; // until it's decided to make tawk.to live
  // If already loaded, just show it
  if (window.Tawk_API?.showWidget) {
    window.Tawk_API.showWidget();
    return;
  }

  // If script already in DOM but API not ready yet, wait for it
  if (document.querySelector('script[src*="tawk.to"]')) {
    await waitForTawkAPI();
    if (window.Tawk_API?.showWidget) {
      window.Tawk_API.showWidget();
    }
    return;
  }

  // Create Tawk API object before adding script
  window.Tawk_API = window.Tawk_API || {};
  window.Tawk_LoadStart = new Date();

  // Inject script
  const s1 = document.createElement("script");
  s1.async = true;
  s1.src = appEnvironment == 'https://app.culturehcm.com/backend/api' ? process.env.VUE_APP_TAWK_TO_URL_PRODUCTION : process.env.VUE_APP_TAWK_TO_URL_DEFAULT;
  s1.charset = 'UTF-8';
  s1.setAttribute('crossorigin', '*');
  console.log('load', appEnvironment, s1.src);
  document.body.appendChild(s1);

  console.log('Tawk script injected');

  // Wait for it to load
  await new Promise((resolve) => {
    s1.onload = resolve;
  });

  console.log('Tawk script loaded');

  // Wait until Tawk_API is ready
  await waitForTawkAPI();

  if (window.Tawk_API?.showWidget) {
    window.Tawk_API.showWidget();
  }
}

// Helper function to wait for Tawk_API readiness
function waitForTawkAPI() {
  return new Promise((resolve) => {
    const check = setInterval(() => {
      if (window.Tawk_API?.showWidget) {
        clearInterval(check);
        resolve();
      }
    }, 100);
  });
}



export function removeTawkTo() {
  return; // until it's decided to make tawk.to live
  if (window.Tawk_API?.hideWidget) {
    window.Tawk_API.hideWidget();
  }

  const tawkScript = document.querySelector('script[src*="tawk.to"]');
  if (tawkScript) tawkScript.remove();

  delete window.Tawk_API;
  delete window.Tawk_LoadStart;

  console.log('Tawk removed');
}


// GET /notifications list item (and the realtime broadcast payload, same shape):
// { id, title, content, date, urgency, is_read, read_at, is_manager, action: { id, path, resource } | null }
export function normalizeNotification(el) {
  const plainText = stripHtmlToSingleLine(el?.content);
  return {
    id: el?.id ?? null,
    title: el?.title || plainText,
    description: el?.content || "",
    normalizedDescription: plainText,
    urgency: el?.urgency || null,
    isManager: !!el?.is_manager,
    action: el?.action || null,
    // Kept as the boolean read/unread flag — the existing convention every
    // template already checks (record.read_at, !item.read_at, etc).
    read_at: el?.is_read ? true : null,
    // The API's own read_at is the actual "when" timestamp, separate from
    // the boolean above — only meaningful to display once read.
    readAt: el?.read_at ? el.read_at.slice(0, 16) : null,
    // "2026-07-23 13:00:13" -> "2026-07-23 13:00"
    date: el?.date ? el.date.slice(0, 16) : null,
  };
}


function stripHtmlToSingleLine(html) {
  if (!html) return "";

  // Convert common HTML entities
  const txt = document.createElement("textarea");
  txt.innerHTML = html;
  let decoded = txt.value;

  // Replace <br> with space, remove other tags
  decoded = decoded
    .replace(/<br\s*\/?>/gi, " ")
    .replace(/<[^>]+>/g, "")
    .replace(/\s+/g, " ") // collapse multiple spaces
    .trim();

  return decoded;
}









